module.exports = __webpack_public_path__ + "img/Veronika_kendoje_2.789995fc.jpg";